import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import config from '../../config';
import EditFuelRecord from './sub/editFuelRecord';

import {
    getFuelRecords,
    deleteFuelRecord,
} from '../../actions/fuel_records_actions';
import {
    getCars,
} from '../../actions/cars_actions';

class FuelTracker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: [],
            loaded: false,
            showEditFuelRecord: false,
            editRecord: null,
        };

        this.renderList = this.renderList.bind(this);
    }

    componentDidMount() {
        this.props.getFuelRecords();
        this.props.getCars();
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.cars.length > 0) {
            this.setState({
                loaded: true,
            });
        }
    }

    renderList() {
        return this.props.fuelRecords.map(record => {
            const car = this.props.cars.find(car => {
               if(car.key === record.carKey)
                   return true;
            });

            return (
                <tr key={record.key}>
                    <td>
                        {moment(record.dateAdd).locale('sk').format('LLL')}
                    </td>
                    <td>{car.name}</td>
                    <td>{record.sum}</td>
                    <td>
                        <img
                            src={record.billPhotoURL}
                            alt="bill"
                            className="img-responsiv img-thumbnail"
                            style={{width: '100%', maxHeight: '170px', maxWidth: '170px', objectFit: "cover"}}
                        />
                    </td>
                    <td>{record.type}</td>
                    <td>{record.km}</td>
                    <td>
                        {record.dateAdd > (moment().valueOf() - config.fuelRecordEditTime) &&
                        <div className="btn-group-vertical">
                            <button
                                type="button"
                                className="btn btn-default btn-primary"
                                onClick={() => {
                                    if(record.dateAdd > (moment().valueOf() - config.fuelRecordEditTime))
                                        this.setState({
                                            showEditFuelRecord: true,
                                            editRecord: record,
                                        });
                                }}
                            >
                                Upraviť
                            </button>
                            <button
                                type="button"
                                className="btn btn-default btn-danger"
                                onClick={() => {
                                    if(record.dateAdd > (moment().valueOf() - config.fuelRecordEditTime)) {
                                        this.props.deleteFuelRecord(record);
                                        if(this.state.editRecord)
                                            if(this.state.editRecord.key === record.key)
                                                this.setState({
                                                    showEditFuelRecord: false,
                                                    editRecord: record,
                                                });
                                    }
                                }}
                            >
                                Zmazať
                            </button>
                        </div>
                        }
                    </td>
                </tr>
            );
        })
    }

    render() {
        if(!this.state.loaded)
            return <div className="alert alert-info">Načítam...</div>;

        return (
            <div>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3 className="panel-title">Fuel Tracking</h3></div>
                    <div className="panel-body">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                <tr>
                                    <th>Datum </th>
                                    <th>Auto </th>
                                    <th>Suma </th>
                                    <th>Bloček </th>
                                    <th>Typ </th>
                                    <th>KM </th>
                                    <th>Akcie </th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.props.fuelRecords &&
                                    this.renderList()
                                }
                                <tr>
                                    <td colSpan={7}>
                                        <button
                                            className="btn btn-default btn-primary"
                                            type="button"
                                            onClick={() => {
                                                this.setState({
                                                    showEditFuelRecord: true,
                                                    editRecord: null,
                                                })
                                            }}
                                        >
                                            Pridať nový záznam
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {
                    this.state.showEditFuelRecord &&
                    this.state.editRecord &&
                    <EditFuelRecord
                        editRecord={this.state.editRecord}
                        afterSubmit={function() {
                            this.setState({
                                showEditFuelRecord: false,
                                editRecord: null,
                            });
                        }.bind(this)}
                    />
                }
                {
                    this.state.showEditFuelRecord &&
                    !this.state.editRecord &&
                    <EditFuelRecord
                        afterSubmit={function() {
                            this.setState({
                                showEditFuelRecord: false,
                            });
                        }.bind(this)}
                    />
                }
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getFuelRecords,
        getCars,
        deleteFuelRecord,
    }, dispatch);
}

function mapStateToProps({ fuelRecords, cars }) {
    return { fuelRecords, cars };
}

export default connect(mapStateToProps, mapDispatchToProps)(FuelTracker);


// WEBPACK FOOTER //
// ./src/app/components/fuelTracker/fuelTracker.jsx